import template from './needALoanFamilySelect.html';
import controller from './needALoanFamilySelect.controller';
import './needALoanFamilySelect.scss';

let needALoanFamilySelectComponent = {
  restrict: 'E',
  bindings: {
    families: '<',
    codeLoanSimulation: '<',
    onOptionSelect: '&',
  },
  template,
  controller,
};

export default needALoanFamilySelectComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/needALoanFamilySelect/needALoanFamilySelect.component.js